import type { Session, Sessions } from "accounts"
import { Analytics } from "cookiesConsent/domain/analytics"
import { UserConsent, performance } from "cookiesConsent/domain/consent"

export class VisitorIdentity {
  private readonly analytics: Analytics
  private readonly sessions: Sessions

  constructor(analytics: Analytics, sessions: Sessions) {
    this.analytics = analytics
    this.sessions = sessions
  }

  confirm = (): Promise<void> => {
    if (this.analytics.remembersCustomer()) {
      return this.sessions
        .current()
        .then(this.forgetIfSignedOut)
        .catch(this.keep)
    } else {
      return Promise.resolve()
    }
  }

  forgetIfWithdrawn = (from: UserConsent, to: UserConsent): void => {
    if (from.withdrawnIn(to, performance)) {
      this.forget()
    } else {
      this.keep()
    }
  }

  forget = (): void => {
    this.analytics.forget()
  }

  private forgetIfSignedOut = (session: Session): void => {
    session.present({
      signedIn: this.keep,
      signedOut: this.forget,
      unknown: this.keep
    })
  }

  private keep = (): void => {}
}
